var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9167 9.66667H10.2584L10.025 9.44167C11.025 8.275 11.5417 6.68333 11.2584 4.99167C10.8667 2.675 8.93337 0.825001 6.60003 0.541667C3.07503 0.108334 0.108366 3.075 0.5417 6.6C0.825033 8.93333 2.67503 10.8667 4.9917 11.2583C6.68337 11.5417 8.27503 11.025 9.4417 10.025L9.6667 10.2583V10.9167L13.2084 14.4583C13.55 14.8 14.1084 14.8 14.45 14.4583C14.7917 14.1167 14.7917 13.5583 14.45 13.2167L10.9167 9.66667ZM5.9167 9.66667C3.8417 9.66667 2.1667 7.99167 2.1667 5.91667C2.1667 3.84167 3.8417 2.16667 5.9167 2.16667C7.9917 2.16667 9.6667 3.84167 9.6667 5.91667C9.6667 7.99167 7.9917 9.66667 5.9167 9.66667Z",
    fill: "#96A397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.be4d1411e0f2981f8952d3265bf7065a.svg";
export { ForwardRef as ReactComponent };